module.exports = __webpack_public_path__ + "img/skip-button.b4c7219d.png";